// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detailed-table[data-v-2d2bb9a8] {\n  padding-left: 50px;\n}\n.detailed-table .text-red[data-v-2d2bb9a8] {\n  color: #f56c6c !important;\n}\n", ""]);
// Exports
module.exports = exports;
